module.exports = __webpack_public_path__ + "img/codepen.8db9e3a3.svg";